module.exports = __webpack_public_path__ + "img/alxq5.9fd8bb6f.png";